import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mastimanch/ui-components';
import { AuthProvider } from './auth-config';
import App from './App';
import './styles/globals.css';
import './config/amplify';
import { PostHogProvider, PostHogErrorBoundary } from '@posthog/react';

const posthogKey = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN || '';
const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

const posthogOptions = {
  api_host: posthogHost,
  person_profiles: 'identified_only' as const,
};

// Configure global fetch to automatically prefix relative API URLs with the production endpoint when built
const apiEndpoint = import.meta.env.VITE_API_ENDPOINT || '';
if (apiEndpoint && apiEndpoint.startsWith('http')) {
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    if (typeof input === 'string' && input.startsWith('/api/')) {
      input = `${apiEndpoint.replace(/\/$/, '')}${input}`;
    }
    return originalFetch(input, init);
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
      <PostHogErrorBoundary fallback={<div className="flex h-screen items-center justify-center text-gray-800 font-semibold">Something went wrong. Please try again later.</div>}>
        <ThemeProvider>
          <AuthProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
        </ThemeProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);